module.exports = __webpack_public_path__ + "img/2.cb400936.jpg";